import { useEffect, useState } from "react";
import { fetchCampaigns, createCampaign, deleteCampaign } from "./api";
import { FaPlay, FaPause, FaTrash, FaEdit } from "react-icons/fa";

const Campaigns = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [newCampaign, setNewCampaign] = useState({
    name: '',
    description: '',
    startDate: '',
    endDate: '',
    segments: [],
    enabled: true
  });

  useEffect(() => {
    loadCampaigns();
  }, []);

  const loadCampaigns = async () => {
    const data = await fetchCampaigns();
    setCampaigns(data || []);
  };

  const handleCreateCampaign = async (e) => {
    e.preventDefault();
    await createCampaign(newCampaign);
    setShowCreateForm(false);
    setNewCampaign({
      name: '',
      description: '',
      startDate: '',
      endDate: '',
      segments: [],
      enabled: true
    });
    loadCampaigns();
  };

  return (
    <div className="campaigns-container">
      <div className="campaigns-header">
        <h1>Marketing Campaigns</h1>
        <button 
          className="create-btn"
          onClick={() => setShowCreateForm(true)}
        >
          Create Campaign
        </button>
      </div>

      {showCreateForm && (
        <div className="create-form">
          <form onSubmit={handleCreateCampaign}>
            <div className="form-group">
              <label>Campaign Name</label>
              <input
                type="text"
                value={newCampaign.name}
                onChange={(e) => setNewCampaign({...newCampaign, name: e.target.value})}
                required
              />
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea
                value={newCampaign.description}
                onChange={(e) => setNewCampaign({...newCampaign, description: e.target.value})}
              />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Start Date</label>
                <input
                  type="date"
                  value={newCampaign.startDate}
                  onChange={(e) => setNewCampaign({...newCampaign, startDate: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>End Date</label>
                <input
                  type="date"
                  value={newCampaign.endDate}
                  onChange={(e) => setNewCampaign({...newCampaign, endDate: e.target.value})}
                  required
                />
              </div>
            </div>
            <div className="form-actions">
              <button type="submit" className="submit-btn">Create Campaign</button>
              <button 
                type="button" 
                className="cancel-btn"
                onClick={() => setShowCreateForm(false)}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="campaigns-grid">
        {campaigns.map(campaign => (
          <div key={campaign.itemId} className="campaign-card">
            <div className="campaign-header">
              <h3>{campaign.metadata.name}</h3>
              <span className={`status-badge ${campaign.enabled ? 'active' : 'inactive'}`}>
                {campaign.enabled ? 'Active' : 'Inactive'}
              </span>
            </div>
            <p className="campaign-description">{campaign.metadata.description}</p>
            <div className="campaign-dates">
              <div className="date-item">
                <span>Start:</span>
                <span>{new Date(campaign.startDate).toLocaleDateString()}</span>
              </div>
              <div className="date-item">
                <span>End:</span>
                <span>{new Date(campaign.endDate).toLocaleDateString()}</span>
              </div>
            </div>
            <div className="campaign-stats">
              <div className="stat-item">
                <span>Segments</span>
                <span>{campaign.segments?.length || 0}</span>
              </div>
              <div className="stat-item">
                <span>Conversions</span>
                <span>{campaign.conversions || 0}</span>
              </div>
            </div>
            <div className="campaign-actions">
              <button className="action-btn">
                {campaign.enabled ? <FaPause /> : <FaPlay />}
              </button>
              <button className="action-btn">
                <FaEdit />
              </button>
              <button 
                className="action-btn delete"
                onClick={() => deleteCampaign(campaign.itemId)}
              >
                <FaTrash />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Campaigns;
